<template>
  <v-container fluid class="exams">
    <v-card flat>
      <v-card-title>
        <p>My Deferrals</p>
        <v-spacer />
        <v-btn @click="redirectToCard" color="primary"
          >Apply For Deferral</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-data-table
          :items="deferrals"
          :sort-by="['documentDate']"
          :sort-desc="[true]"
          class="bookings"
          hide-default-footer
          :headers="headers"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.programme`]="{ item }">
            <span>{{ item["programme"] }}</span>
          </template>
          <template v-slot:[`item.documentDate`]="{ item }">
            <span>{{ formatDate(item["documentDate"]) }}</span>
          </template>
          <template v-slot:[`item.session`]="{ item }">
            <span>{{ item["intakeYear"] }}, {{ item["intakeSemester"] }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span
              ><v-icon size="12" :color="statusColor[item.status]"
                >mdi-radiobox-marked</v-icon
              >
              {{ item["status"] }}</span
            >
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item["amount"] | currencyFormat }}</span>
          </template>
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  :to="{
                    name: 'DeferralCard',
                    params: { code: encrypt(item.no) },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="20" class="mr-1">
                      mdi-eye
                    </v-icon>
                    View
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item
                  @click="deleteDeferral(item)"
                  v-if="item.status === 'Open'"
                >
                  <span class="table-exam">
                    <v-icon color="deep-orange darken-1" class="mr-1"
                      >delete</v-icon
                    >
                    Delete
                  </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import status from "@/packages/applications/status";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "ExamDeferral",
  data: () => ({
    headers: [
      { text: "#S/N", value: "ID", sortable: false },
      { text: "Reference No.", value: "no", sortable: false },
      { text: "Applied On", value: "documentDate", sortable: false },
      { text: "Programme", value: "programme", sortable: false },
      { text: "Stage", value: "stage", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
  }),
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Deferral/getExamDeferrals");
    });
  },
  mounted() {},
  computed: {
    deferrals() {
      return this.$store.getters["Deferral/deferralGetter"]("deferrals");
    },
    statusColor() {
      return status;
    },
  },
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    encrypt(item) {
      return helper.encrypt(item);
    },
    redirectToCard() {
      this.$router.push({ name: "DeferralCard" });
    },
    deleteDeferral(item) {
      this.$confirm.show({
        title: "Delete Deferral Entry",
        text: "Are you sure you want to delete this deferral entry, this action is irreversible",
        onConfirm: () => {
          this.$store.dispatch("Deferral/deleteDeferral", { ...item });
        },
      });
    },
  },
};
</script>

<style scoped></style>
